import React, { useEffect } from 'react';
import type { AtcCellModel } from './cell.model';
import { useAtcCellInView } from './use-atc-cell-in-view';

export const AtcCellInViewGate: React.FC<{
  cellModel: AtcCellModel;
  pollingEnabled: boolean;
  children: React.ReactNode;
}> = ({ cellModel, pollingEnabled, children }) => {
  const { cellRef, cellInView } = useAtcCellInView();

  useEffect(() => {
    cellModel.setVisible(pollingEnabled && cellInView);
  }, [cellModel, pollingEnabled, cellInView]);

  return (
    <div ref={cellRef} className="h-full min-h-[1px] w-full">
      {children}
    </div>
  );
};
